import React from "react";
import { Text } from "../../styles/Common";
import { theme } from "../../styles/theme";
import { CustomDatePicker } from "./styles";

export const DatePicker = ({
  placeholder,
  required,
  suffix,
  helper,
  error,
  disabled,
  onChange,
  onPressEnter,
  width,
  label,
  sizeLabel,
  weightLabel,
  colorLabel,
  placeholderColor,
  ...rest
}) => {
  return (
    <div style={{ width }}>
      {label && (
        <Text
          weight={weightLabel}
          size={sizeLabel || theme.fonts.size.default}
          color={colorLabel || theme.colors.gray200}
          mt="0px"
          mb="7px"
          ml="6px"
          align="left"
        >
          {label} {required && <span style={{ color: theme.colors.red }}>*</span>}
        </Text>
      )}
      <CustomDatePicker
        placeholder={placeholder}
        suffix={suffix}
        status={error ? "error" : ""}
        disabled={disabled}
        onChange={onChange}
        style={{ width: width }}
        placeholderColor={placeholderColor}
        className={helper ? "has-helper" : ""}
        {...rest}
      />
      {helper && (
        <Text size={theme.fonts.size.xs} color={theme.colors.red} mt="2px">
          {helper}
        </Text>
      )}
    </div>
  );
};
